import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { isClosedValid } from "./closureDisplay";

export function ClosureStatusButton({
  label,
  valid,
  message,
}: {
  label: string;
  valid: boolean;
  message: any;
}) {
  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          <div style={{ textAlign: "left" }}>
            {valid ? null : <strong>Why?</strong>}
            <div style={{ marginTop: "4px" }}>{message}</div>
          </div>
        </Tooltip>
      }
    >
      <button
        type="button"
        style={{
          padding: "4px 10px",
          borderRadius: "6px",
          border: "none",
          fontSize: "12px",
          cursor: "pointer",
          backgroundColor: valid ? "green" : "#dc3545",
          color: "white",
        }}
      >
        {label}
      </button>
    </OverlayTrigger>
  );
}

export function ClosureStatusButtons({ row }: { row: any }) {
  const v = row.validationSummary || {};
  return (
    <div
      style={{
        display: "flex",
        gap: "6px",
        flexWrap: "wrap",
        width: "100%",
      }}
    >
      <ClosureStatusButton
        label="Roster Data"
        valid={Boolean(v.rosterData?.valid)}
        message={v.rosterData?.message}
      />
      <ClosureStatusButton
        label="Directory"
        valid={Boolean(v.directory?.valid)}
        message={v.directory?.message}
      />
      <ClosureStatusButton
        label="Program"
        valid={Boolean(v.program?.valid)}
        message={v.program?.message}
      />
      <ClosureStatusButton
        label="Pictures"
        valid={Boolean(v.pictures?.valid)}
        message={v.pictures?.message}
      />
      <ClosureStatusButton
        label="Validated & Closed"
        valid={isClosedValid(row)}
        message={
          isClosedValid(row)
            ? "Retreat data confirmed."
            : "Retreat data not confirmed."
        }
      />
    </div>
  );
}
